<template>
  <div id="drop">
    <div class="d-flex position-relative">
      <div class="page-size-field">
        <input
            :class="isOpen ? 'focus':''"
            type="input"
            value="Common sizes"
            class="open-button"
            readonly
            @focus="gotFocus"
            @blur="loseFocus"
            @click="onClick"
            @select="clearTextSelection">
        <icon
            name="chevron"
            class="icon-open"/>
      </div>
      <span
          v-if="$store.getters['activeProduct/getIsVideoMoodOn']"
          class="tooltp d-flex align-items-center">?
        <div class="info">
          If you change the size of this page, all other pages will be adjusted to match the new dimensions. This might cause the overall design to change
        </div>
      </span>
      <div
          v-if="isOpen"
          class="dimension position-absolute" >
        <template v-for="group in sizeGroups">
          <div
              v-if="group.sizes.length"
              :key="group.title"
              class="dimension-group">
            <div class="dimension-group-title">{{ group.title }}</div>
            <div
                v-for="element in group.sizes"
                :key="element.id"
                class="dropdownhighlight__option--highlight"
                @mousedown.stop="changeProductSize(element)">
              <size-tag
                  :id="element.id"
                  :name="element.name==='Facebook'?'Facebook / LinkedIn':element.name"
                  :size="(element.unit === 'Inches')?element.inches:element.size"
                  :unit="element.unit"
                  :is-favourite="element.isFavourite"/>
            </div>
          </div>
        </template>
      </div>
      <div
          class="panel-icon-btn ms-8"
          @click.stop="resetProductSize"> <icon name="rest"/></div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';
import Size from './Size';


export default {
  name:       'ProductPageSize',
  components: {
    'size-tag': Size,
  },
  data() {
    return {
      productSizes: [
        {
          id:          '1', name:        'Flyer', size:        '612 x 792', inches:      '8.5" x 11"', isFavourite: false, unit:        'Inches',
        },
        {
          id:          '2', name:        'Facebook', size:        '1200 x 628', inches:      '16.66" x 8.72"', isFavourite: false, unit:        'Pixels',
        },
        {
          id:          '3', name:        'Twitter', size:        '1024 x 512', inches:      '14.22" x 7.11"', isFavourite: false, unit:        'Pixels',
        },
        {
          id:          '4', name:        'Instagram', size:        '1080 x 1080', inches:      '15.00" x 15.00"', isFavourite: false, unit:        'Pixels',
        },
      ],
      isOpen: false,
      name:   'Common',
    };
  },
  computed: {
    getProductSizes() {
      const customSizes    = [
        {
          id:          '1', name:        'Flyer', size:        '612x792', inches:      '8.5" x 11"', isFavourite: false, unit:        'Inches',
        },
        {
          id:          '2', name:        'Facebook', size:        '1200x628', inches:      '16.66" x 8.72"', isFavourite: false, unit:        'Pixels',
        },
        {
          id:          '3', name:        'Twitter', size:        '1024x512', inches:      '14.22" x 7.11"', isFavourite: false, unit:        'Pixels',
        },
        {
          id:          '4', name:        'Instagram', size:        '1080x1080', inches:      '15.00" x 15.00"', isFavourite: false, unit:        'Pixels',
        },
      ];
      const sizeToReturn   = [];
      const favouriteSizes = this.$store.getters.getFavouriteSizes;
      if (favouriteSizes) {
        favouriteSizes.forEach((favouriteSize) => {
          sizeToReturn.push({
            id:   favouriteSize.Id,
            name: favouriteSize.Name,
            size: favouriteSize.Unit === 'Pixels' ? `${parseInt(favouriteSize.Width, 10)}x${parseInt(favouriteSize.Height, 10)}`
                : `${(parseFloat(favouriteSize.Width)) * 72} x ${(parseFloat(favouriteSize.Height)) * 72}`,
            inches:      `${parseFloat(favouriteSize.Width).toFixed(2)}" x ${parseFloat(favouriteSize.Height).toFixed(2)}"`,
            isFavourite: true,
            unit:        favouriteSize.Unit,
          });
        });
        return sizeToReturn.concat(customSizes);
      }
      return this.productSizes;
    },
    sizeGroups() {
      return [
        { title: 'Favorites', sizes: this.getProductSizes.filter(size => size.isFavourite) },
        { title: 'Presets', sizes: this.getProductSizes.filter(size => !size.isFavourite) },
      ];
    },
  },
  mounted() {
    EventBus.$on(ApplicationEventTypes.LeftPanelEvents.CLOSE_PRODUCT_SIZE_DROPDOWN, this.closeDropDown);
    EventBus.$on(ApplicationEventTypes.ObjectSelectionEvents.CLEARED, this.closeDropDown);
  },
  beforeDestroy() {
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.CLOSE_PRODUCT_SIZE_DROPDOWN, this.closeDropDow);
    EventBus.$off(ApplicationEventTypes.ObjectSelectionEvents.CLEARED, this.closeDropDown);
  },
  methods: {
    onMouseDown() {
      console.log('mousedown');
    },
    clearTextSelection(e) {
      e.target.selectionStart = e.target.selectionEnd;
    },
    loseFocus(e) {
      this.$nextTick(() => {
        this.isOpen = false;
      });
    },
    onClick() {
      this.isOpen = !this.isOpen;
    },
    gotFocus() {
      console.log('Focus got');
      // this.isOpen = true;
    },
    resetProductSize() {
      // EventBus.$emit('setDefaultCropValue')
      this.name = 'Common';
      setTimeout(() => {
        EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.RESET_PRODUCT_SIZE);
      }, 0);
    },
    changeProductSize(object) {
      this.name = object.name;
      EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_PRODUCT_SIZE_FROM_DROPDOWN, object);
      this.isOpen = false;
    },
    closeDropDown() {
      this.isOpen = false;
    },
  },

};
</script>

<style  lang="scss" scoped>
.dimension{
  z-index: 2;
  top: 42px;
  left: 0;
  right: 0;
  max-height: 590px;
  padding: 6px;
  background: $white;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.06), 0px 2px 6px rgba(0, 0, 0, 0.04);
  overflow: auto;
}
.dimension-group-title{
  padding: 10px 12px 4px;
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: $grey60;
}
.dropdownhighlight__option--highlight{
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    background-color: #f3f4f6;
  }
}
.page-size-field {
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
}
.open-button{
  width: 100%;
  height: 36px;
  padding: 0 32px 0 12px;
  border: 1px solid transparent;
  border-radius: 8px;
  background-color: #f3f4f6;
  font-size: 12.5px;
  color: $grey90;
  cursor: pointer;
  user-select: none;
  &.focus{
    border-color: $blue50 !important;
  }
  &:hover{
    border-color: $grey30;
  }
}
.icon-open{
  position: absolute;
  top: 10px;
  right: 10px;
  min-width: 16px;
  min-height: 16px;
  pointer-events: none;
  color: $grey70;

  ::v-deep svg {
    display: block;
    width: 16px;
    height: 16px;
  }
}

.tooltp{
  position: relative;
  margin-left: 8px;
  font-size: 12px;
  color: black;
  .info{
    position: absolute;
    display: none;
    width: 180px;
    height: 120px;
    left: 50%;
    bottom: 81%;
    transform: translate(-74%);
    background-color: white;
    padding: 10px;
    border-radius: 5px;
    z-index: 99;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.04);

    &:after{
      content: "";
      display: block;
      bottom: -3px;
      height: 15px;
      width: 15px;
      background-color: white;
      right: 39px;
      transform: rotate(45deg);
      position: absolute;
    }
  }
  &:hover{
    .info{
      display: block;
    }
  }
}

</style>
